import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const contactsTableTooltips = TOOLTIPS_TEXTS.contactsTable;

export const CONTACTS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const CONTACTS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

// Commented code needs for when Contacts will be brought back to the original logic and flow
export const CONTACTS_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'name',
    // 'jobTitle',
    'contactType',
    // 'companyType',
    // 'company',
    'email',
    // 'mobilePhone',
    'division',
    'community',
    'options'
  ],
  displayedTitles: [
    'Name',
    // 'Job Title',
    'Contact Type',
    // 'Company Type',
    // 'Company',
    'Email',
    // 'Mobile Phone',
    'Division',
    'Community',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    // { sorting: true },
    { sorting: true },
    // { sorting: true },
    // { sorting: true },
    { sorting: true },
    // { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    contactsTableTooltips.name,
    // contactsTableTooltips.jobTitle,
    contactsTableTooltips.contactType,
    // contactsTableTooltips.companyType,
    // contactsTableTooltips.company,
    contactsTableTooltips.email,
    // contactsTableTooltips.phone,
    contactsTableTooltips.division,
    contactsTableTooltips.community
  ],
  options: null,
  dataSource: []
};
